import api from '@/shared/api/api-client';

import type { OnboardingGateway } from './onboarding.gateway';

/** Wire shape of `GET /auth/invitations/validate` (backend snake_case). */
interface InvitationWire {
  email: string;
  first_name: string;
  last_name: string;
  role: string;
}

/**
 * Real implementation over the shared api client. The single place that knows
 * the endpoints and the snake_case wire format (kept 1:1 with the original
 * `Onboarding` page's calls). The client prefixes `/v1`, and `/v1/auth/*`
 * endpoints are CSRF-exempt; the accept response body is unused.
 */
export const httpOnboardingGateway: OnboardingGateway = {
  validateInvitation: async (token) => {
    const wire = await api.get<InvitationWire>(
      `/auth/invitations/validate?token=${encodeURIComponent(token)}`,
    );
    return {
      email: wire.email,
      firstName: wire.first_name,
      lastName: wire.last_name,
      role: wire.role,
    };
  },
  acceptInvitation: async ({ token, password, confirmPassword }) => {
    await api.post('/auth/invitations/accept', {
      token,
      password,
      confirm_password: confirmPassword,
    });
  },
};
